import apiClient from '../api-client';
import type { ModelWithVersions } from '@geely/shared';

export const modelsApi = {
  listActive: async () => {
    const response = await apiClient.get<ModelWithVersions[]>('/models/active');
    return response.data;
  },
};
